import React, {  useCallback, useEffect, useState } from 'react'
import { Breadcrumb, CardBasic, SButton, SFooter, SImage, SInputImage, TextInput } from '../../components';
import { AvatarMale, Ceklis } from '../../assets/index';
import { useLocation, useNavigate } from 'react-router-dom';
import './tab.css';
import { API_BASE_URL, BE_BASE_URL } from '../../config';
import { useSelector } from 'react-redux';
import ShowAlert from '../../components/ShowAlert';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

function DoctorReview() {
  const user = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state;

  const [loading, setLoading] = useState(true);
  const [patientData, setPatientData] = useState(null);

  const [examination, setExamination] = useState([]);
  const [diagnosis, setDiagnosis] = useState([]);
  const [treatment, setTreatment] = useState([]);
  const [receipt, setReceipt] = useState([]);
  const [images, setImages] = useState([]);
  const [medical, setMedical] = useState([]);

  const [products, setProducts] = useState([]);
  const [masterProducts, setMasterProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [defaultDiagnosisOptions, setDefaultDiagnosisOptions] = useState([]);
  const [masterTreatments, setMasterTreatments] = useState([]);
  const [masterPackages, setMasterPackages] = useState([]);

  const [isSaving, setIsSaving] = useState(false);
  
  const [errors, setErrors] = useState({});
  const [showNotif, setShowNotif] = useState(false);
  
  const [notifType, setNotifType] = useState('success');
  const [notifMessage, setNotifMessage] = useState('Form has been successfully submitted!');

  const Patient = useCallback(async () => {
    try {
          const token = localStorage.getItem('access_token');
          const response = await fetch(
              `${API_BASE_URL}/auth/patient/norm/${data?.no_medical_record}`,
              {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json',
                      ...(token && { Authorization: `Bearer ${token}` }),
                  }
              }
          );
          if(!response.ok) {
              const errorData = await response.json().catch(() => ({}));
              alert(errorData.message || 'Gagal mengambil data!');
              
              return;
          }
          const patientDatas = await response.json();
          setPatientData(patientDatas.data[0]);
      }finally{
          
      }
  },[data]);

  const fetchDataExamination =  useCallback(async () => {
        try {
          const token = localStorage.getItem('access_token');
          const response = await fetch(`${API_BASE_URL}/auth/examinations/patient/${data?.klinik_id}/${data?.no_medical_record}/${data?.no_regist}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              ...(token && { Authorization: `Bearer ${token}` }),
            }
          });
          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            setExamination([
              { 
                type: 'error', 
                data: [],
                content: errorData.message || 'Data Not Found!',
                code: 404
              }
            ]);
            return;
          }
          const examination = await response.json();

          if(examination.code === 200){
            setExamination([
              {
                type: 'success',
                data: examination.data,
                content: 'Data berhasil diambil',
                code: 200
              }
            ]);
          }else{
            setExamination([
              {
                type: 'error',
                data: [],
                content: examination.message || 'Data Not Found!',
                code: 404
              }
            ]);
          }
        } catch (error) {
          setExamination([
              { 
                type: 'error', 
                content: error || 'Error fetching patient data',
                code: 'UNKNOWN_ERROR'
              }
          ]);
        }finally{
        }
  },[data]);

  const fetchDataDiagnosis = useCallback(async () => {
    try {
        const token = localStorage.getItem('access_token');
        const response = await fetch(`${API_BASE_URL}/auth/diagnoses_patient/${data?.klinik_id}/${data?.no_medical_record}/${data?.no_regist}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...(token && { Authorization: `Bearer ${token}` }),
            }
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            setDiagnosis([
                {
                    type: 'error',
                    data: [],
                    content: errorData.message || 'Data Not Found!',
                    code: 404
                }
            ]);
            return;
        }
        const diagnosis = await response.json();

        if(diagnosis.code === 200){
          setDiagnosis([
            {
              type: 'success',
              data: diagnosis.data,
              content: 'Data berhasil diambil',
              code: 200
            }
          ]);
        }else{
          setDiagnosis([
            {
              type: 'error',
              data: [],
              content: diagnosis.message || 'Data Not Found!',
              code: 404
            }
          ]);
        }
    } catch (error) {
        setDiagnosis([
            { 
              type: 'error', 
              data: [],
              content: error || 'Error fetching diagnosis data',
              code: 'UNKNOWN_ERROR'
            }
        ]);
    } finally {
    }
  },[data]);

  const fetchDataTreatment = useCallback(async () => {
    try {
        const token = localStorage.getItem('access_token');
        const response = await fetch(`${API_BASE_URL}/auth/treatment_patient/${data?.klinik_id}/${data?.no_medical_record}/${data?.no_regist}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...(token && { Authorization: `Bearer ${token}` }),
            }
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            setTreatment([
                {
                    type: 'error',
                    data: [],
                    content: errorData.message || 'Data Not Found!',
                    code: 404
                }
            ]);
            return;
        }
        const treatment = await response.json();
        if(treatment.code === 200){
          setTreatment([
            {
              type: 'success',
              data: treatment.data,
              content: 'Data berhasil diambil',
              code: 200
            }
          ]);
        }else{
          setTreatment([
            {
              type: 'error',
              data: [],
              content: treatment.message || 'Data Not Found!',
              code: 404
            }
          ]);
        }
    } catch (error) {
      setTreatment([
          { 
            type: 'error', 
            data: [],
            content: error || 'Error fetching treatment data',
            code: 'UNKNOWN_ERROR'
          }
      ]);
    } finally {
    }
  },[data]);

  const fetchDataProduct = useCallback(async () => {
    try {
      const token = localStorage.getItem('access_token');
      const getProducts = await fetch(`${API_BASE_URL}/auth/product_patient_review/${data?.klinik_id}/${data?.no_medical_record}/${data?.no_regist}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
        }
      });
      const productsData = await getProducts.json();
      if (getProducts.ok && Array.isArray(productsData.data)) {
        setProducts({
          status: true,
          data: productsData.data || [],
          message: productsData.message,
          code: 200
        });
      } else {
        setProducts({
          status: false,
          data: [],
          message: productsData.message || 'Failed to fetch products',
          code: 404
        });
      }
    } catch (error) {
      // console.error('Error fetching products:', error);
      setProducts({
        status: false,
        data: [],
        message: error.message || 'Failed to fetch products',
        code: 500
      });
    } finally {
    }
  },[data]);

  const fetchDataRecipe = useCallback(async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await fetch(`${API_BASE_URL}/auth/receipt_patient_review/${data?.klinik_id}/${data?.no_medical_record}/${data?.no_regist}`, {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              ...(token && { Authorization: `Bearer ${token}` }),
          }
      });
      if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          setReceipt([
              {
                  type: 'error',
                  data: [],
                  content: errorData.message || 'Data Not Found!',
                  code: 404
              }
          ]);
          return;
      }
      const recipe = await response.json();
      if(recipe.code === 200){
          setReceipt([
            {
              type: 'success',
              data: recipe.data,
              content: 'Data berhasil diambil',
              code: 200
            }
          ]);
        }else{
          setReceipt([
            {
              type: 'error',
              data: [],
              content: recipe.message || 'Data Not Found!',
              code: 404
            }
          ]);
        }
    } catch (error) {
      setReceipt([
          { 
            type: 'error', 
            data: [],
            content: error || 'Error fetching receipt data',
            code: 'UNKNOWN_ERROR'
          }
      ]);
    } finally {
    }
  },[data]);

  const fetchCategoriesDiagnosis = useCallback(async () => {
    try {
      const token = localStorage.getItem('access_token');
      const getCategoriesDiagnosis = await fetch(`${API_BASE_URL}/auth/diagnoses_categories/all`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const categoriesData = await getCategoriesDiagnosis.json();
      if (getCategoriesDiagnosis.ok) {
        setCategories({
          data: categoriesData.data || [],
          message: categoriesData.message,
          status: true
        });
      } else {
        setCategories({
          status: false,
          data: [],
          message: categoriesData.message || 'Failed to fetch categories',
        })
      }
    } catch (error) {
      setCategories({
          status: false,
          data: [],
          message: error.message || 'Failed to fetch categories',
        })
    } finally {
    }
  },[]);

  const fetchMasterDiagnosis = useCallback(async (inputValue = '') => {
    try {
      const token = localStorage.getItem('access_token');
      // Ganti endpoint agar support pencarian

      const url = inputValue
      ? `${API_BASE_URL}/auth/master_diagnoses/query/diagnosis?search=${encodeURIComponent(inputValue)}`
      : `${API_BASE_URL}/auth/master_diagnoses/query/diagnosis?limit=10`;

      const response = await fetch(url, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
      });
      const masterData = await response.json();
      if (response.ok && Array.isArray(masterData.data)) {
        // setMasterDiagnosis({
        //   status: true,
        //   data: masterData.data || [],
        //   message: masterData.message,
        // });
        // Untuk react-select Async, return array option
        return masterData.data
          ? masterData.data.map(diag => ({
              value: diag.id,
              label: `${diag.diagnosis_code} - ${diag.diagnosis_name}`,
            }))
          : [];
      } else {
        // setMasterDiagnosis({
        //   status: false,
        //   data: [],
        //   message: masterData.message || 'Failed to fetch master diagnosis',
        // });
        return [];
      }
    } catch (error) {
      // setMasterDiagnosis({
      //   status: false,
      //   data: [],
      //   message: error.message || 'Failed to fetch master diagnosis',
      // });
      return [];
    }
  }, []);
  
  const fetchTreatments = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/master_treatment_get_klinik/${data?.klinik_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      });
      if (!response.ok) {
        throw new Error('Failed to fetch master treatments');
      } 
      const result = await response.json();
      setMasterTreatments(result.data || []);
    } catch (error) {
      console.error('Error fetching master treatments:', error);
    }
  },[data]);

  const fetchPackage = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/master_treatment_package_get_klinik/${data?.klinik_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      });
      if (!response.ok) {
        throw new Error('Failed to fetch packages');
      }
      const result = await response.json();
      setMasterPackages(result.data || []);
    } catch (error) {
      console.error('Error fetching packages:', error);
      return [];
    }
  },[data]);

  const fetchMasterProduct = useCallback(async (inputValue = '') => {
    try {
      const token = localStorage.getItem('access_token');
      const getProducts = await fetch(`${API_BASE_URL}/auth/product_klinik/${data?.klinik_id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
        }
      });

      const productsData = await getProducts.json();
      if (getProducts.ok && Array.isArray(productsData.data)) {
        setLoading(false);
        setMasterProducts({
          status: true,
          data: productsData.data || [],
          message: productsData.message,
          code: 200
        });
        return productsData.data
          .filter(product =>  product.name.toLowerCase().includes(inputValue.toLowerCase()))
          .map(product => ({
            value: product.id,
            label: product.name,
          }));
      } else {
        setLoading(false);
        setMasterProducts({
          status: false,
          data: [],
          message: productsData.message || 'Failed to fetch products',
          code: 404
        });
        return [];
      }
    } catch (error) {
      setLoading(false);
      setMasterProducts({
        status: false,
        data: [],
        message: error.message || 'Failed to fetch products',
        code: 500
      });
      return [];
    }
  }, [data]);

  const fetchPhotos =  useCallback(async () => {
        try {
          const token = localStorage.getItem('access_token');
          const response = await fetch(`${API_BASE_URL}/auth/photo_patient/${data?.klinik_id}/${data?.no_medical_record}/${data?.no_regist}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          });
          if (response.ok) {
            const data = await response.json();
            setImages(data.data || []);
          }
        } catch (error) {
          console.error('Error fetching photos:', error);
          setImages([]);
        }
  }, [data]);

  const fetchMedical = useCallback(async () => {
      try {
        const token = localStorage.getItem('access_token');
        const response = await fetch(`${API_BASE_URL}/auth/patient/medical_record/${data?.klinik_id}/${data?.no_medical_record}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setMedical({
            code: 200,
            message: 'Medical records fetched successfully',
            data: data.data || []
          });
        }else {
          setMedical({
            code: 404,
            message: 'Failed to fetch medical records',
            data: []
          });
        }
      } catch (error) {
        setMedical({
          code: 500,
          message: 'Internal Server Error',
          data: []
        });
      }
  }, [data]);

  useEffect(() => {
    if(loading){
      Promise.all([
        Patient(),
        fetchDataExamination(),
        fetchDataDiagnosis(),
        fetchDataTreatment(),
        fetchDataProduct(),
        fetchDataRecipe(),
        fetchTreatments(),
        fetchPackage(),
        fetchCategoriesDiagnosis(),
        fetchMasterDiagnosis('').then((options) => {
          setDefaultDiagnosisOptions(options);
        }),
        fetchMasterProduct(),
        fetchPhotos(),
        fetchMedical()
      ])
      .finally(() => 
        setLoading(false)
      );
    }
  }, [loading,Patient,fetchDataExamination,fetchDataDiagnosis,fetchCategoriesDiagnosis,fetchDataTreatment,fetchDataProduct,fetchTreatments,fetchPackage,fetchDataRecipe,fetchMasterDiagnosis,fetchMasterProduct,fetchPhotos,fetchMedical]);

  if (loading) {
      return (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
              <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
              </div>
          </div>
      );
  }

  const formatDateInternational = (dateString) => {
    if (!dateString) return '';
    // Gunakan waktu lokal agar tidak mundur satu hari
    const dateObj = new Date(dateString);
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    const dateStr = dateObj.toLocaleDateString('en-US', options).replace(',', '');
    const [month, day, year] = dateStr.split(' ');
    return `${day} ${month} ${year}`;
  }

  const Profile = () => {
    return (
      <>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-6'>
          <div className='d-flex flex-center flex-shrink-0 bg-light rounded w-100px h-100px w-lg-150px h-lg-150px me-7 mb-4'>
              <SImage source={AvatarMale} alt={'no image'} className={'mw-100 mw-lg-100 rounded'}/>
          </div>
          <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                  <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-1'>
                          <span className='text-gray-800 text-hover-primary fs-2 fw-bold me-3'>{patientData?.full_name}</span>
                          <span className="badge badge-light-success me-auto">In Progress</span>
                      </div>
                      <div className="d-flex flex-wrap text-gray-400">
                          <div className='d-flex align-items-center me-4'>
                              <i className='ki-outline ki-profile-circle  me-2'></i>
                              <span>{patientData?.no_medical_record}</span>
                          </div>
                          <div className='d-flex align-items-center me-4'>
                              <i className="bi bi-telephone me-2"></i>
                              <span>{patientData?.phone_number}</span>
                          </div>
                          <div className='d-flex align-items-center'>
                              <i className="bi bi-envelope me-2"></i>
                              <span>{patientData?.email}</span>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="d-flex flex-wrap justify-content-start">
                <div className="col-xl-6">
                  {/* <div className="d-flex flex-column">
                      <div className="d-flex w-100 fs-8 text-gray-500 mb-3">
                        <span>Profile Compleation</span>
                      </div>
                      <div className="h-8px bg-light rounded mb-3">
                        <div className="bg-success rounded h-8px" role="progressbar" style={{ width:'60%'}}></div>
                        <span className='fw-bold'>80%</span>
                      </div>
                  </div> */}
                </div>
              </div>
          </div>
        </div>
        <div className="separator"></div>
        <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
          <li className="nav-item">
            <a className="nav-link text-active-primary py-5 me-6 active" data-bs-toggle="tab" href="#kt_assesment">Assesment</a>
          </li>
          <li className="nav-item">
            <a className="nav-link text-active-primary py-5 me-6" data-bs-toggle="tab" href="#kt_photo">Photo Patient</a>
          </li>
          <li className="nav-item">
            <a className="nav-link text-active-primary py-5 me-6" data-bs-toggle="tab" href="#kt_record">Medical Record</a>
          </li>
        </ul>
      </>
    )
  }

  const Tab = ({ patient }) => {
    const [activeTab, setActiveTab] = useState('examination');
      
    const toggleTab = (tabName) => {
      setActiveTab(tabName);
    };

    const Assesment = ({ activeTab, setActiveTab, toggleTab, patient }) => {

      const [rowsDiagnosis, setRowsDiagnosis] = useState([{ categories: '', diagnosis: '', priority: '', createdBy: '' }]);
      const [rowsTreatment, setRowsTreatment] = useState([{ categories_treatment: '', treatment: '', quantity: '', price: '', createdBy: '' }]);
      const [rowsProducts, setRowsProducts] = useState([{ product: '', quantity:'', price: '', createdBy: '' }]);
      const [rowsRecipe, setRowsRecipe] = useState([{ product: '', quantity:'', pemakaian: '',rule: '', createdBy: '' }]);

      const Examination = () => {
        const exam = examination[0]?.data ?? [];

        const [currentPage, setCurrentPage] = useState(1);
        const [limit, setLimit] = useState(2); // Default 2 data per halaman
        const totalPages = Math.ceil(exam.length / limit);
        
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [selectedDetail,setSelectedDetail] = useState(null);

        if (isSaving) {
            return (
              <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(255,255,255,0.3)', // transparan
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            );
        }

        const handleLimitChange = (newLimit) => {
          setLimit(Number(newLimit));
          setCurrentPage(1); // Reset ke halaman pertama
        };

        const paginatedData = exam.slice((currentPage - 1) * limit, currentPage * limit);
        
        const handlePageChange = (page) => {
          if (page === 'prev') {
            setCurrentPage((prev) => Math.max(prev - 1, 1));
          } else if (page === 'next') {
            setCurrentPage((prev) => Math.min(prev + 1, totalPages));
          } else {
            setCurrentPage(page);
          }
        };

        const handleDetailClick = (detail) => {
          setSelectedDetail(detail);
          setIsModalOpen(true);
        };

        const handleCloseModal = () => {
          setIsModalOpen(false);
          setSelectedDetail(null);
        };

        const handleCloseConfirm = () => {
            setShowNotif(false);

            // Navigasi setelah notifikasi ditutup
            // const basePath = location.pathname.split('/')[1];
            // navigate(`/${basePath}`);
        };

        const validateForm = () => {
          const form = document.getElementById('examination-form');
          const formData = new FormData(form);
          const errors = {};

          for (const [key, value] of formData.entries()) {
            if (!value) {
              errors[key] = 'This field is required';
            }
          }

          if (Object.keys(errors).length > 0) {
            setErrors(errors);
            return false;
          }

          return true;
        };

        const handleSubmit = async (e) => {
          e.preventDefault();
          const isValid = validateForm();

          if (!isValid) {
            return;
          }

          const formData = new FormData(e.target);
          const datas = Object.fromEntries(formData);
          // setFormExam((prev) => ({ ...prev, ...datas }));

          // Ambil tanggal hari ini (atau dari input, sesuai kebutuhan)
          const today = new Date().toISOString().slice(0, 10);
          const alreadyExists = paginatedData.some(item => {
            // Sesuaikan property tanggal pada item, misal item.created_at
            const itemDate = item.created_at?.slice(0, 10);
            return itemDate === today;
          });

          if (alreadyExists) {
            const confirmAdd = window.confirm('Data pada tanggal yang sama sudah ada. Apakah Anda ingin menambah data lagi?');
            if (!confirmAdd) {
              return;
            }
          }

          const formulir = {
            no_medical_record: patient.no_medical_record,
            no_regist: data.no_regist,
            klinik_id: data.klinik_id,
            doctor_id: user.user.id,
            allergy_information: datas.alergy,
            anamnesa: datas.anamnesa,
            recommendation: datas.recomendation,
            notes: datas.notes_examination,
            created_by: user.user.id,
          };
          setIsSaving(true);

          try{
            const response = await fetch(`${API_BASE_URL}/auth/examinations`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
              },
              body: JSON.stringify(formulir),
            });
            
            if (!response.ok) {
              setNotifType('danger');
              setNotifMessage(response.message || 'Gagal membuat examination!');
              setShowNotif(true);
              setIsSaving(false);
              return;
            }
            
            await fetchDataExamination();
            setShowNotif(true);
            setActiveTab('examination');
          } catch (error) {
            setNotifType('danger');
            setNotifMessage(error.message || 'Failed to create examination!');
            setShowNotif(true);
            setIsSaving(false);
          } finally {
            setIsSaving(false);
            setActiveTab('examination');
          }

          e.target.reset();
        };

        const handleClear = () => {
          const form = document.getElementById('examination-form');
          const formData = new FormData(form);
          formData.forEach((value, key) => {
            form.elements[key].value = '';
          });

          setErrors({});
        };

        return (
          <>
            <div className='row g-6 g-xl-9 mb-5'>
              <div className="col-md-6 col-xxl-6">
                <CardBasic 
                    className2={'d-flex flex-column p-2'}
                >
                    <div className='text-start'>
                      <ul className="nav nav-pills" id="pills-tab" role="tablist">
                        <li className="nav-item w-100" role="presentation">
                          <button
                            className={`nav-link btn btn-primary w-100`}
                            onClick={() => toggleTab("examination")}
                          >
                            Examination
                          </button>
                        </li>
                      </ul>  
                    </div>
                </CardBasic>
                <div className={`tab-content ${activeTab === "examination" ? "active" : ""} examination`} id="pills-tabContent">
                  {activeTab === "examination" && (
                  <div className="p-6 bg-light rounded border">
                    <div>
                      <h4 className="mb-4">Examination</h4>
                      <h5 className="mb-3 text-muted">Examination Result in Patient</h5>
                      <form onSubmit={handleSubmit} id='examination-form'>
                        <div className="mb-3">
                          <label htmlFor="alergy" className="form-label">Information Alergy<span className="text-danger">*</span></label>
                          <textarea className="form-control" name='alergy' id="alergy" rows="3"></textarea>
                          {errors.alergy && <div className="text-danger">{errors.alergy}</div>}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="anamnesa" className="form-label">Anamnesa<span className="text-danger">*</span></label>
                          <textarea className="form-control" name='anamnesa' id="anamnesa" rows="3" ></textarea>
                          {errors.anamnesa && <div className="text-danger">{errors.anamnesa}</div>}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="recomendation" className="form-label">Recommendation<span className="text-danger">*</span></label>
                          <textarea className="form-control" name='recomendation' id="recomendation" rows="3"></textarea>
                          {errors.recomendation && <div className="text-danger">{errors.recomendation}</div>}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="notes" className="form-label">Notes<span className="text-danger">*</span></label>
                          <textarea className="form-control" name='notes_examination' id="notes" rows="3"></textarea>
                          {errors.notes_examination && <div className="text-danger">{errors.notes_examination}</div>}
                        </div>
                        <div className="d-flex justify-content-end">
                          <SButton
                              className={ 'btn btn-secondary me-2' }
                              variant={'secondary'}
                              type={'button'}
                              onClick={handleClear}
                              disabled={isSaving ? true : false}
                          >
                            Clear
                          </SButton>
                          <SButton
                              className={ isSaving ? 'btn btn-secondary' :'btn btn-primary'}
                              children={
                                  isSaving ? 
                                  (
                                      <>
                                          Please Wait...<span className="spinner-border spinner-border-sm me-2"></span>
                                      </>
                                  )
                                  : 'Save'
                              }
                              variant={isSaving ? 'secondary' : 'primary'}
                              type={'submit'}
                              disabled={isSaving ? true : false}
                          >
                              {isSaving ? (
                                  <>
                                    Please Wait...<span className="spinner-border spinner-border-sm me-2"></span>
                                  </>
                              ) : 'Submit'}
                          </SButton>
                        </div>
                      </form>
                    </div>
                  </div>
                  )}
                </div> 
              </div>

              <div className="col-md-6 col-xxl-6">
                  <CardBasic 
                      className2={'d-flex flex-column p-2'}
                  >
                    <div className='text-start'>
                      <ul className="nav nav-pills" id="pills-tab" role="tablist">
                        <li className="nav-item w-100" role="presentation">
                          <button
                            className="nav-link btn btn-primary w-100"
                            onClick={() => toggleTab("examination")}
                          >
                            History Examination
                          </button>
                        </li>
                      </ul>  
                    </div>
                  </CardBasic>

                  <div className={`tab-content ${activeTab === "examination" ? "active" : ""} examination`} id="pills-tabContent">
                    {activeTab === "examination" && (
                        <div className="p-6 bg-light rounded border">
                          <h3 className="mb-4">Examination</h3>
                          <h5 className="mb-3 text-muted">History Examination</h5>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th scope="col">Date</th>
                                <th scope="col">Anamnesa</th>
                                <th scope="col">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                paginatedData.length > 0 ? (
                                  paginatedData.map((item) => (
                                    <tr key={item.id}>
                                      <td>{formatDateInternational(item.created_at)}</td>
                                      <td>{item.anamnesa}</td>
                                  <td>
                                    <button className="btn btn-light-success btn-sm" 
                                      onClick={() => handleDetailClick(item)}>Detail</button>
                                  </td>
                                </tr>
                              )) ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">No data available</td>
                                </tr>
                              )}
                            </tbody>
                          </table>  
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div>
                              <select className="form-select" 
                              style={{ width: 'auto' }} 
                              onChange={(e) => handleLimitChange(e.target.value)}>
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="20">20</option>
                              </select>
                            </div>
                            <div>
                              <nav>
                                <ul className="pagination mb-0">
                                  <li className="page-item">
                                    <button className="page-link" 
                                    onClick={() => handlePageChange('prev')} 
                                    disabled={currentPage === 1}>
                                      Previous
                                    </button>
                                  </li>
                                  {Array.from({ length: totalPages }, (_, index) => (
                                    <li key={index} 
                                    className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                      <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                        {index + 1}
                                      </button>
                                    </li>
                                  ))}
                                  <li className="page-item">
                                    <button className="page-link" onClick={() => handlePageChange('next')} disabled={currentPage === totalPages}>
                                      Next
                                    </button>
                                  </li>
                                </ul>
                              </nav>
                            </div>
                          </div>
                        </div>
                    )}
                  </div>  
              </div>
            </div>

            {isModalOpen && selectedDetail && (
              <div className="modal modal-lg show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Examination</h5>
                      <span className="badge bg-info ms-3">{selectedDetail.date}</span>
                      <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                    </div>
                    <div className="modal-body">
                      <div className="details-grid">
                        <div className="detail-item">
                          <strong>Information Alergy:</strong>
                          <span>{selectedDetail.allergy_information || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Anamnesa:</strong>
                          <span>{selectedDetail.anamnesa || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Recommendation:</strong>
                          <span>{selectedDetail.recommendation || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Notes:</strong>
                          <span>{selectedDetail.notes || 'N/A'}</span>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            { showNotif && (
                    // <ShowAlert 
                    // title={notifType === 'success' ? 'Ok, got it!' : 'Oops!'}
                    // message={notifMessage}
                    // pic={notifType === 'success' ? Ceklis : undefined}
                    // show={showNotif} 
                    // setShow={setShowNotif}
                    // onClose={handleCloseConfirm}
                    // swal={notifType === 'success' ? 'swal2-success' : 'swal2-danger'}
                    // />
                    <ShowAlert 
                    title={notifType === 'success' ? 'Ok, got it!' : 'Oops!'}
                    message={notifMessage}
                    svg={notifType === 'success' ? 'svg-icon-success' : (notifType === 'danger' ? 'svg-icon-danger' : 'svg-icon-warning')}
                    show={showNotif} 
                    setShow={setShowNotif}
                    onClose={handleCloseConfirm}
                    swal={notifType === 'success' ? 'swal2-success' : (notifType === 'danger' ? 'swal2-error' : 'swal2-warning')}
                    />
            )}
          </>
        );
      }

      const Diagnosis = ({ activeTab, setActiveTab, toggleTab, rowsDiagnosis, setRowsDiagnosis }) => {
        const diag = diagnosis[0]?.data ?? [];

        // const [rows, setRows] = useState([]);
        const [currentPage, setCurrentPage] = useState(1);
        const [limit, setLimit] = useState(2); // Default 2 data per halaman

        const [isModalOpen, setIsModalOpen] = useState(false);
        const [selectedDetail,setSelectedDetail] = useState(null);
        
        if (isSaving) {
            return (
              <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(255,255,255,0.3)', // transparan
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            );
        }

        const totalPages = Math.ceil(diag.length / limit);
       
        const handleLimitChange = (newLimit) => {
          setLimit(Number(newLimit));
          setCurrentPage(1); // Reset ke halaman pertama
        };

        const paginatedData = diag.slice((currentPage - 1) * limit, currentPage * limit);

        const handlePageChange = (page) => {
          if (page === 'prev') {
            setCurrentPage((prev) => Math.max(prev - 1, 1));
          } else if (page === 'next') {
            setCurrentPage((prev) => Math.min(prev + 1, totalPages));
          } else {
            setCurrentPage(page);
          }
        };

        const handleDetailClick = (detail) => {
          setSelectedDetail(detail);
          setIsModalOpen(true);
        };

        const handleCloseModal = () => {
          setIsModalOpen(false);
          setSelectedDetail(null);
        };

        const handleSubmitDiagnosis = async (e) => {
          e.preventDefault();

          const formData = new FormData(e.target);
          const datas = Object.fromEntries(formData);

          const diagnosisRows = [];
          let i = 0;
          while (datas[`categories_diagnosis_${i}`] !== undefined) {
            diagnosisRows.push({
              categories: datas[`categories_diagnosis_${i}`],
              diagnosis: datas[`diagnosis_${i}`],
              priority: datas[`priority_diagnosis_${i}`],
              createdBy: datas[`by_diagnosis_${i}`],
            });
            i++;
          }

          setIsSaving(true);

          const promises = diagnosisRows.map(row => {
              const payload = {
                no_medical_record: data.no_medical_record,
                no_regist: data.no_regist,
                klinik_id: data.klinik_id,
                doctor_id: user.user.id,
                categories: row.categories,
                diagnosis_type: row.priority,
                diagnosis_id: row.diagnosis,
                created_by: row.createdBy,
              };

              return fetch(`${API_BASE_URL}/auth/diagnoses_patient/create`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
                body: JSON.stringify(payload),
              }).then(async response => {
                if (!response.ok) {
                  const errorData = await response.json().catch(() => ({}));
                  throw new Error(errorData.message || 'Gagal membuat diagnosis!');
                }
                return response.json();
              });
          })

          try {
            await Promise.all(promises);
            setNotifType('success');
            setNotifMessage('Diagnosis berhasil ditambahkan!');
            setShowNotif(true);
            // setRows([]);
            setActiveTab("diagnosis"); // Pastikan tab tetap aktif
            await fetchDataDiagnosis(); // Update tabel diagnosis
          } catch (error) {
            setNotifType('danger');
            setActiveTab("diagnosis"); 
            setNotifMessage(error.message || 'Gagal membuat diagnosis!');
            setShowNotif(true);
          } finally {
            setIsSaving(false);
            setActiveTab("diagnosis"); 
          }
        };
        return (
          <>
            <div className='row g-6 g-xl-9 mb-5'>
              <div className="col-md-6 col-xxl-6">
                <CardBasic 
                    className2={'d-flex flex-column p-2'}
                >
                    <div className='text-start'>
                      <ul className="nav nav-pills" id="pills-tab" role="tablist">
                        <li className="nav-item w-100" role="presentation">
                          <button
                            className="nav-link btn btn-primary w-100"
                            onClick={() => toggleTab("diagnosis")}
                          >
                            Diagnosis
                          </button>
                        </li>
                      </ul>  
                    </div>
                </CardBasic>
                <div className="tab-content" id="pills-tabContent">
                  {activeTab === "diagnosis" && (
                  <div className="p-6 bg-light rounded border">
                    <form onSubmit={handleSubmitDiagnosis} >
                    <div>
                      <h4 className="mb-4">Add Diagnosis</h4>
                      <h5 className="mb-3 text-muted">Add diagnosis for patient</h5>
                      {rowsDiagnosis.map((row, index) => (
                        <div className="row mb-5 align-items-center" key={index}>
                          <div className="col">
                            <Select 
                              name={`categories_diagnosis_${index}`}
                              options={categories?.data?.map(cat => ({ value: cat.icd_range, label: cat.category_name }))}
                              value={
                                row.categories
                                  ? { value: row.categories, label: categories?.data?.find(cat => cat.icd_range === row.categories)?.category_name || '' }
                                  : null
                              }
                              isClearable={true}
                              placeholder="Select a categories"
                              onChange={(selectedOption) => {
                                const newRows = [...rowsDiagnosis];
                                newRows[index].categories = selectedOption?.value;
                                setRowsDiagnosis(newRows);
                              }}
                              styles={{
                                control: (provided) => ({ ...provided, minWidth: 180, maxWidth: '100%', whiteSpace: 'normal' }),
                                menu: (provided) => ({ ...provided, zIndex: 9999 })
                              }}
                            />
                          </div>
                          <div className="col">
                            <AsyncSelect
                              cacheOptions
                              loadOptions={fetchMasterDiagnosis}
                              defaultOptions={defaultDiagnosisOptions}
                              isClearable={true}
                              placeholder="Select a diagnosis"
                              name={`diagnosis_${index}`}
                              value={
                                row.diagnosis
                                  ? {
                                      value: row.diagnosis,
                                      label: row.diagnosis_label || '',
                                    }
                                  : null
                              }
                              onChange={(selectedOption) => {
                                const newRows = [...rowsDiagnosis];
                                newRows[index].diagnosis = selectedOption?.value;
                                newRows[index].diagnosis_label = selectedOption?.label || '';
                                setRowsDiagnosis(newRows);
                              }}
                              styles={{
                                control: (provided) => ({ ...provided, minWidth: 180, maxWidth: '100%', whiteSpace: 'normal' }),
                                menu: (provided) => ({ ...provided, zIndex: 9999 })
                              }}
                            />
                          </div>
                          <div className="col">
                            <Select
                              name={`priority_diagnosis_${index}`}
                              options={[
                                { value: 'Primary', label: 'Primary' },
                                { value: 'Secondary', label: 'Secondary' },
                              ]}
                              value={
                                row.priority_diagnosis
                                  ? { value: row.priority_diagnosis, label: row.priority_diagnosis }
                                  : null
                              }
                              isClearable={true}
                              placeholder="Select a Priority"
                              onChange={(selectedOption) => {
                                const newRows = [...rowsDiagnosis];
                                newRows[index].priority_diagnosis = selectedOption?.value;
                                setRowsDiagnosis(newRows);
                              }}
                              styles={{
                                control: (provided) => ({ ...provided, minWidth: 180, maxWidth: '100%', whiteSpace: 'normal' }),
                                menu: (provided) => ({ ...provided, zIndex: 9999 })
                              }}
                            
                            />
                           
                          </div>
                          <div className="col">
                            <TextInput
                              type={'text'}
                              placeholder={'Created By'}
                              name={`by_diagnosis_${index}`}
                              value={row.createdBy || user.user.full_name}
                              style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed'}}
                              readOnly
                            />
                          </div>
                          <div className="col-1">
                            <button
                              type="button"
                              className="btn btn-sm btn-light-danger"
                              onClick={() => {
                                setRowsDiagnosis(rowsDiagnosis.filter((_, i) => i !== index));
                              }}
                            >
                              X
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-sm btn-light-primary"
                        onClick={() => setRowsDiagnosis([
                          ...rowsDiagnosis,
                          { categories: '', diagnosis: '', priority: '', createdBy: user.user.full_name }
                        ])}
                      >
                        + Add Another Variation
                      </button>
                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-light-primary"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                    </form>
                  </div>
                  )}
                </div> 
              </div>

              <div className="col-md-6 col-xxl-6">
                <CardBasic 
                    className2={'d-flex flex-column p-2'}
                >
                  <div className='text-start'>
                    <ul className="nav nav-pills" id="pills-tab" role="tablist">
                      <li className="nav-item w-100" role="presentation">
                        <button
                            className="nav-link btn btn-primary w-100"
                            onClick={() => toggleTab("diagnosis")}
                        >
                          History Diagnosis
                        </button>
                      </li>
                    </ul>  
                  </div>
                </CardBasic>

                <div className="tab-content" id="pills-tabContent">
                  {activeTab === "diagnosis" && (
                      <div className="p-6 bg-light rounded border">
                        <h4 className="mb-4">Diagnosis</h4>
                        <h5 className="mb-3 text-muted">History Diagnosis</h5>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th scope="col">Date</th>
                              <th scope="col">Diagnosis</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedData.map((item,idx) => (
                              <tr key={`${item.id}-${idx}`}>
                                <td>{formatDateInternational(item.created_at)}</td>
                                <td>{item.diagnosis_name}</td>
                                <td>
                                  <button className="btn btn-light-success btn-sm" onClick={() => handleDetailClick(item)}>Detail</button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>  
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div>
                            <select className="form-select" 
                            style={{ width: 'auto' }} 
                            onChange={(e) => handleLimitChange(e.target.value)}>
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="15">15</option>
                              <option value="20">20</option>
                            </select>
                          </div>
                          <div>
                            <nav>
                              <ul className="pagination mb-0">
                                <li className="page-item">
                                  <button className="page-link" 
                                  onClick={() => handlePageChange('prev')} 
                                  disabled={currentPage === 1}>
                                    Previous
                                  </button>
                                </li>
                                {Array.from({ length: totalPages }, (_, index) => (
                                  <li key={index} 
                                  className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                      {index + 1}
                                    </button>
                                  </li>
                                ))}
                                <li className="page-item">
                                  <button className="page-link" onClick={() => handlePageChange('next')} disabled={currentPage === totalPages}>
                                    Next
                                  </button>
                                </li>
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                  )}
                </div>  
              </div>
            </div>

            {isModalOpen && selectedDetail && (
              <div className="modal modal-lg show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Diagnosis</h5>
                      <span className="badge bg-info ms-3">{selectedDetail.date}</span>
                      <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                    </div>
                    <div className="modal-body">
                      <div className="details-grid">
                        <div className="detail-item">
                          <strong>Categories:</strong>
                          <span>{selectedDetail.diagnosis_code || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Diagnosis:</strong>
                          <span>{selectedDetail.diagnosis_name || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Priority:</strong>
                          <span>{selectedDetail.diagnosis_type || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Created By:</strong>
                          <span>{selectedDetail.created_by_name || 'N/A'}</span>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        );
      }

      const Treatment = ({ activeTab, setActiveTab, toggleTab, rowsTreatment, setRowsTreatment }) => {
        const treat =  Array.isArray(treatment) && treatment.length > 0 && Array.isArray(treatment[0]?.data) && treatment[0].data.length > 0
          ? treatment[0].data
          : [];
        const [currentPage, setCurrentPage] = useState(1);
        const [limit, setLimit] = useState(2); // Default 2 data per halaman

        const [isModalOpen, setIsModalOpen] = useState(false);
        const [selectedDetail,setSelectedDetail] = useState(null);

        if (isSaving) {
            return (
              <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(255,255,255,0.3)', // transparan
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            );
        }

        const totalPages = Math.ceil(treat.length / limit);

        // const handleAddRow = () => {
        //   setRows([...rows, { treatment: '', quantity: '', price: '', createdBy: '' }]);
        // };

        // const handleRemoveRow = (index) => {
        //   setRows(rows.filter((_, i) => i !== index));
        // };

       
        const handleLimitChange = (newLimit) => {
          setLimit(Number(newLimit));
          setCurrentPage(1); // Reset ke halaman pertama
        };

        const paginatedData = treat.slice((currentPage - 1) * limit, currentPage * limit);

        const handlePageChange = (page) => {
          if (page === 'prev') {
            setCurrentPage((prev) => Math.max(prev - 1, 1));
          } else if (page === 'next') {
            setCurrentPage((prev) => Math.min(prev + 1, totalPages));
          } else {
            setCurrentPage(page);
          }
        };

        const handleDetailClick = (detail) => {
          setSelectedDetail(detail);
          setIsModalOpen(true);
        };

        const handleCloseModal = () => {
          setIsModalOpen(false);
          setSelectedDetail(null);
        };

        const handleSubmit= async (e) => {
          e.preventDefault();

          const formData = new FormData(e.target);
          const datas = Object.fromEntries(formData);

          const treatmentRows = [];
          let i = 0;
          while (datas[`treatment_${i}`] !== undefined) {
            treatmentRows.push({
              category: datas[`categories_treatment_${i}`],
              treatment: datas[`treatment_${i}`],
              quantity: datas[`quantity_treatment_${i}`],
              price: datas[`price_treatment_${i}`],
              createdBy: datas[`by_treatment_${i}`],
            });
            i++;
          }

          setIsSaving(true);

          const promises = treatmentRows.map(row => {
              const payload = row.category === 'treatment' ? {
                category: row.category,
                no_medical_record: data.no_medical_record,
                no_regist: data.no_regist,
                klinik_id: data.klinik_id,
                treatment_id: row.treatment,
                qty: row.quantity,
                unit_price: row.price,
                discount_type: 'none',
                discount_value: 0,
                final_price: parseFloat(row.quantity) * parseFloat(row.price),
                created_by: user.user.id
              } : {
                category: row.category,
                no_medical_record: data.no_medical_record,
                no_regist: data.no_regist,
                klinik_id: data.klinik_id,
                package_id: row.treatment,
                qty: row.quantity,
                unit_price: row.price,
                discount_type: 'none',
                discount_value: 0,
                final_price: parseFloat(row.quantity) * parseFloat(row.price),
                created_by: user.user.id
              };

              return fetch(`${API_BASE_URL}/auth/treatment_patient/create`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
                body: JSON.stringify(payload),
              }).then(async response => {
                if (!response.ok) {
                  const errorData = await response.json().catch(() => ({}));
                  throw new Error(errorData.message || 'Gagal membuat treatment!');
                }
                return response.json();
              });
          })

          try {
            await Promise.all(promises);
            setNotifType('success');
            setNotifMessage('Treatment berhasil ditambahkan!');
            setShowNotif(true);
            // setRows([]);
            setActiveTab("treatment"); // Pastikan tab tetap aktif
            await fetchDataTreatment(); // Update tabel treatment
          } catch (error) {
            setNotifType('danger');
            setNotifMessage(error.message || 'Gagal membuat treatment!');
            setShowNotif(true);
          } finally {
            setIsSaving(false);
          }
        };
        
        return (
          <>
            <div className='row g-6 g-xl-9 mb-5'>
              <div className="col-md-6 col-xxl-6">
                <CardBasic 
                    className2={'d-flex flex-column p-2'}
                >
                    <div className='text-start'>
                      <ul className="nav nav-pills" id="pills-tab" role="tablist">
                        <li className="nav-item w-100" role="presentation">
                          <button
                            className="nav-link btn btn-primary w-100"
                            onClick={() => toggleTab("treatment")}
                          >
                            Treatment
                          </button>
                        </li>
                      </ul>  
                    </div>
                </CardBasic>
                <div className="tab-content" id="pills-tabContent">
                  {activeTab === "treatment" && (
                  <div className="p-6 bg-light rounded border">
                  <form onSubmit={handleSubmit}>
                    <div>
                      <h4 className="mb-4">Add Treatment</h4>
                      <h5 className="mb-3 text-muted">Add treatment and package for patient</h5>
                      {rowsTreatment.map((row, index) => (
                        <div className="row mb-3 align-items-center" key={index}>
                          <div className="col" style={{ minWidth: 180 }}>
                            <Select 
                              name={`categories_treatment_${index}`}
                              options={
                                [
                                  { value: 'treatment', label: 'Treatment' },
                                  { value: 'package', label: 'Package' }
                                ]
                              }
                              value={
                                row.categories_treatment
                                  ? { value: row.categories_treatment, label: row.categories_treatment === 'treatment' ? 'Treatment' : 'Package' }
                                  : null
                              }
                              isClearable={true}
                              placeholder="Select a categories"
                              onChange={(selectedOption) => {
                                const newRows = [...rowsTreatment];
                                newRows[index].categories_treatment = selectedOption?.value;
                                newRows[index].treatment = ''; 
                                setRowsTreatment(newRows);
                              }}
                              styles={{
                                control: (provided) => ({ ...provided, minWidth: 180, maxWidth: '100%', whiteSpace: 'normal' }),
                                menu: (provided) => ({ ...provided, zIndex: 9999 })
                              }}
                            />
                          </div>
                          <div className="col" style={{ minWidth: 180 }}>
                            <Select
                              name={`treatment_${index}`}
                              options={
                                row.categories_treatment === 'treatment'
                                  ? masterTreatments.map(item => ({
                                      value: item.id,
                                      label: item.treatment_name
                                    }))
                                  : row.categories_treatment === 'package'
                                  ? masterPackages.map(item => ({
                                      value: item.id,
                                      label: item.package_name
                                    }))
                                  : []
                              }
                              value={
                                row.treatment
                                  ? (
                                      row.categories_treatment === 'treatment'
                                        ? {
                                            value: row.treatment,
                                            label: masterTreatments.find(item => item.id === row.treatment)?.treatment_name || ''
                                          }
                                        : row.categories_treatment === 'package'
                                        ? {
                                            value: row.treatment,
                                            label: masterPackages.find(item => item.id === row.treatment)?.package_name || ''
                                          }
                                        : null
                                    )
                                  : null
                              }
                              isClearable={true}
                              placeholder="Select a treatment"
                              onChange={(selectedOption) => {
                                const newRows = [...rowsTreatment];
                                newRows[index].treatment = selectedOption?.value;
                                if (row.categories_treatment === 'treatment') {
                                  const selected = masterTreatments.find(item => item.id === selectedOption?.value);
                                  newRows[index].quantity = selected?.quantity || 1;
                                  newRows[index].price = selected?.final_price || 0;
                                } else if (row.categories_treatment === 'package') {
                                  const selected = masterPackages.find(item => item.id === selectedOption?.value);
                                  newRows[index].quantity = selected?.quantity || 1;
                                  newRows[index].price = selected?.final_price || 0;
                                }
                                setRowsTreatment(newRows);
                              }}
                              styles={{
                                control: (provided) => ({ ...provided, minWidth: 180, maxWidth: '100%', whiteSpace: 'normal' }),
                                menu: (provided) => ({ ...provided, zIndex: 9999 })
                              }}
                            />
                          </div>
                          <div className="col" style={{ minWidth: 120 }}>
                            <TextInput
                              type={'number'}
                              placeholder={'Quantity'}
                              name={`quantity_treatment_${index}`}
                              value={row.quantity}
                              onChange={e => {
                                const newRows = [...rowsTreatment];
                                newRows[index].quantity = e.target.value;
                                setRowsTreatment(newRows);
                              }}
                              style={{ width: '100%' }}
                            />
                          </div>
                          <div className="col" style={{ minWidth: 120 }}>
                            <TextInput
                              type={'number'}
                              placeholder={'Price'}
                              name={`price_treatment_${index}`}
                              value={row.price}
                              onChange={e => {
                                const newRows = [...rowsTreatment];
                                newRows[index].price = e.target.value;
                                setRowsTreatment(newRows);
                              }}
                              style={{ width: '100%' }}
                            />
                          </div>
                          <div className="col" style={{ minWidth: 180 }}>
                            <TextInput 
                              type={'text'} 
                              placeholder={'Created By'} 
                              name={`by_treatment_${index}`} 
                              value={row.createdBy || user.user.full_name}
                              style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed'}}
                              readOnly
                            />
                          </div>
                          <div className="col-1">
                            <button
                              type="button"
                              className="btn btn-sm btn-light-danger"
                              onClick={() => {
                                setRowsTreatment(rowsTreatment.filter((_, i) => i !== index));
                              }}
                            >
                              X
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-sm btn-light-primary"
                        onClick={() => setRowsTreatment([...rowsTreatment, { treatment: '', quantity: '', price: '', createdBy: user.user.full_name }])}
                      >
                        + Add Another Variation
                      </button>
                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-light-primary"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                    </form>
                  </div>
                  )}
                </div> 
              </div>

              <div className="col-md-6 col-xxl-6">
                <CardBasic 
                    className2={'d-flex flex-column p-2'}
                >
                  <div className='text-start'>
                    <ul className="nav nav-pills" id="pills-tab" role="tablist">
                      <li className="nav-item w-100" role="presentation">
                        <button
                            className="nav-link btn btn-primary w-100"
                            onClick={() => toggleTab("treatment")}
                        >
                          History Treatment
                        </button>
                      </li>
                    </ul>  
                  </div>
                </CardBasic>

                <div className="tab-content" id="pills-tabContent">
                  {activeTab === "treatment" && (
                      <div className="p-6 bg-light rounded border">
                        <h4 className="mb-4">Treatment</h4>
                        <h5 className="mb-3 text-muted">History Treatment</h5>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th scope="col">Date</th>
                              <th scope="col">Treatment</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedData.map((item) => (
                              <tr key={item.id}>
                                <td>{formatDateInternational(item.created_at)}</td>
                                <td>{item.type === 'package' ? item.package_name : item.treatment_name}</td>
                                <td>
                                  <button className="btn btn-light-success btn-sm"
                                    onClick={() => handleDetailClick(item)}
                                  >Detail</button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>  
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <div>
                            <select className="form-select" 
                            style={{ width: 'auto' }} 
                            onChange={(e) => handleLimitChange(e.target.value)}>
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="15">15</option>
                              <option value="20">20</option>
                            </select>
                          </div>
                          <div>
                            <nav>
                              <ul className="pagination mb-0">
                                <li className="page-item">
                                  <button className="page-link" 
                                  onClick={() => handlePageChange('prev')} 
                                  disabled={currentPage === 1}>
                                    Previous
                                  </button>
                                </li>
                                {Array.from({ length: totalPages }, (_, index) => (
                                  <li key={index} 
                                  className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                      {index + 1}
                                    </button>
                                  </li>
                                ))}
                                <li className="page-item">
                                  <button className="page-link" onClick={() => handlePageChange('next')} disabled={currentPage === totalPages}>
                                    Next
                                  </button>
                                </li>
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                  )}
                </div>  
              </div>
            </div>

            {isModalOpen && selectedDetail && (
              <div className="modal modal-lg show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Treatment</h5>
                      <span className="badge bg-info ms-3">{selectedDetail.date}</span>
                      <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                    </div>
                    <div className="modal-body">
                      <div className="details-grid">
                        <div className="detail-item">
                          <strong>Date:</strong>
                          <span>{formatDateInternational(selectedDetail.created_at) || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Worker:</strong>
                          <span>{selectedDetail.worker || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Treatment:</strong>
                          <span>{selectedDetail.type === 'package' ? selectedDetail.package_name : selectedDetail.treatment_name || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Created By:</strong>
                          <span>{selectedDetail.created_by_name || 'N/A'}</span>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        );
      }

      const Products = ({activeTab, setActiveTab, toggleTab, masterProducts ,rowsProducts,setRowsProducts}) => {
        const [currentPage, setCurrentPage] = useState(1);
        const [limit, setLimit] = useState(2); // Default 2 data per halaman

        const [isModalOpen, setIsModalOpen] = useState(false);
        const [selectedDetail,setSelectedDetail] = useState(null);

        let datas = products?.data ?? [];
        const totalPages = Math.ceil(datas.length / limit);

        if (isSaving) {
            return (
              <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(255,255,255,0.3)', // transparan
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            );
        }

       
        const handleLimitChange = (newLimit) => {
          setLimit(Number(newLimit));
          setCurrentPage(1); // Reset ke halaman pertama
        };

        const paginatedData = datas.slice((currentPage - 1) * limit, currentPage * limit);

        const handlePageChange = (page) => {
          if (page === 'prev') {
            setCurrentPage((prev) => Math.max(prev - 1, 1));
          } else if (page === 'next') {
            setCurrentPage((prev) => Math.min(prev + 1, totalPages));
          } else {
            setCurrentPage(page);
          }
        };

        const handleDetailClick = (detail) => {
          setSelectedDetail(detail);
          setIsModalOpen(true);
        };

        const handleCloseModal = () => {
          setIsModalOpen(false);
          setSelectedDetail(null);
        };

        const handleSubmit= async (e) => {
          e.preventDefault();
          // Handle form submission logic here
          const formData = new FormData(e.target);
          const datas = Object.fromEntries(formData);
          
          const productRows = [];
          let i = 0;
          
          while (datas[`product_${i}`] !== undefined) {
            productRows.push({
              product: datas[`product_${i}`],
              quantity: datas[`quantity_product_${i}`],
              price: datas[`price_product_${i}`],
              createdBy: datas[`by_product_${i}`],
            });
            i++;
          }
          
          setIsSaving(true);
          const promises = productRows.map(row => {
              const payload = {
                klinik_id: data.klinik_id,
                no_medical_record: data.no_medical_record,
                no_regist: data.no_regist,
                patient_id: patient.id,
                product_id: row.product,
                quantity: row.quantity,
                price: row.price,
                created_by: user.user.id
              };
              return fetch(`${API_BASE_URL}/auth/product_patient/create`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${user.token}`
                },
                body: JSON.stringify(payload)
              }).then(async response => {
                if (!response.ok) {
                  const errorData = await response.json().catch(() => ({}));
                  throw new Error(errorData.message || 'Gagal membuat product!');
                }
                return response.json();
              });
          });

          try {
            await Promise.all(promises);
            setNotifType('success');
            setNotifMessage('Product berhasil ditambahkan!');
            setShowNotif(true);
            // setRows([]);
            setActiveTab("product"); // Pastikan tab tetap aktif
            await fetchDataProduct(); // Update tabel product
          } catch (error) {
            setNotifType('danger');
            setActiveTab("product"); 
            setNotifMessage(error.message || 'Gagal membuat product!');
            setShowNotif(true);
          } finally {
            setIsSaving(false);
            setActiveTab("product"); 
          }
        };


        return (
          <>
          <div className='row g-6 g-xl-9 mb-5'>
            <div className="col-md-6 col-xxl-6">
              <CardBasic 
                  className2={'d-flex flex-column p-2'}
              >
                  <div className='text-start'>
                    <ul className="nav nav-pills" id="pills-tab" role="tablist">
                      <li className="nav-item w-100" role="presentation">
                        <button
                          className="nav-link btn btn-primary w-100"
                          onClick={() => toggleTab("product")}
                        >
                          Product
                        </button>
                      </li>
                    </ul>  
                  </div>
              </CardBasic>
              <div className="tab-content" id="pills-tabContent">
                {activeTab === "product" && (
                  <form onSubmit={handleSubmit}>
                  <div className="p-6 bg-light rounded border">
                    <div>
                      <h4 className="mb-4">Add Product</h4>
                      <h5 className="mb-3 text-muted">Add product for patient</h5>
                      {rowsProducts.map((row, index) => (
                        <div className="row mb-3 align-items-center" key={index}>
                          <div className="col" style={{ minWidth: 180 }}>
                            <Select 
                              name={`product_${index}`}
                              options={masterProducts.status ? masterProducts.data.filter(prod => prod.group_id === 1).map(prod => ({ value: prod.id, label: prod.name })) : []}
                              value={
                                row.product
                                  ? { value: row.product, label: masterProducts.data.find(prod => prod.id === row.product)?.name || '' }
                                  : null
                              }
                              isClearable={true}
                              placeholder="Select a product"
                              onChange={(selectedOption) => {
                                const newRows = [...rowsProducts];
                                newRows[index].product = selectedOption?.value;
                                const selected = masterProducts.data.find(item => item.id === selectedOption?.value);
                                newRows[index].quantity = selected?.min_stok || 1;
                                newRows[index].price = selected?.final_price || 0;
                                setRowsProducts(newRows);
                              }}
                              styles={{
                                control: (provided) => ({ ...provided, minWidth: 180, maxWidth: '100%', whiteSpace: 'normal' }),
                                menu: (provided) => ({ ...provided, zIndex: 9999 })
                              }}
                            />
                          </div>
                          <div className="col" style={{ minWidth: 120 }}>
                            <TextInput type={'number'} 
                            placeholder={'Quantity'} 
                            name={`quantity_product_${index}`} 
                            value={row.quantity}
                            onChange={(e) => {
                              const newRows = [...rowsProducts];
                              newRows[index].quantity = e.target.value;
                              setRowsProducts(newRows);
                            }}
                            />
                          </div>
                          <div className="col" style={{ minWidth: 120 }}>
                            <TextInput type={'number'} 
                            placeholder={'Price'} 
                            name={`price_product_${index}`} 
                            value={row.price}
                            onChange={(e) => {
                              const newRows = [...rowsProducts];
                              newRows[index].price = e.target.value;
                              setRowsProducts(newRows);
                            }}
                            />
                          </div>
                          <div className="col" style={{ minWidth: 180 }}>
                           <TextInput type={'text'} 
                            placeholder={'Created By'} 
                            name={`by_product_${index}`} 
                            value={row.createdBy || user.user.full_name}
                            style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed'}}
                            readOnly
                           />
                          </div>
                          <div className="col-1" style={{ minWidth: 40 }}>
                            <button
                              type="button"
                              className="btn btn-sm btn-light-danger"
                              onClick={() => setRowsProducts(rowsProducts.filter((_, i) => i !== index))}
                            >
                              X
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-sm btn-light-primary"
                         onClick={() => setRowsProducts([...rowsProducts, { product: '', quantity: '', price: '', createdBy: '' }])}
                      >
                        + Add Another Variation
                      </button>
                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-light-primary"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                  </form>
                )}
              </div> 
            </div>

            <div className="col-md-6 col-xxl-6">
              <CardBasic 
                  className2={'d-flex flex-column p-2'}
              >
                <div className='text-start'>
                  <ul className="nav nav-pills" id="pills-tab" role="tablist">
                    <li className="nav-item w-100" role="presentation">
                      <button
                          className="nav-link btn btn-primary w-100"
                          onClick={() => toggleTab("product")}
                      >
                        History Product
                      </button>
                    </li>
                  </ul>  
                </div>
              </CardBasic>

              <div className="tab-content" id="pills-tabContent">
                {activeTab === "product" && (
                  <div className="p-6 bg-light rounded border">
                    <h4 className="mb-4">Product</h4>
                    <h5 className="mb-3 text-muted">History Product</h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">Date</th>
                          <th scope="col">Product</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.map((item) => (
                          <tr key={item.id}>
                            <td>{formatDateInternational(item.created_at)}</td>
                            <td>{item.product_name}</td>
                            <td>
                              <button className="btn btn-light-success btn-sm"
                              onClick={() => handleDetailClick(item)}
                              >Detail</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>  
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        <select className="form-select" 
                        style={{ width: 'auto' }} 
                        onChange={(e) => handleLimitChange(e.target.value)}>
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                        </select>
                      </div>
                      <div>
                        <nav>
                          <ul className="pagination mb-0">
                            <li className="page-item">
                              <button className="page-link" 
                              onClick={() => handlePageChange('prev')} 
                              disabled={currentPage === 1}>
                                Previous
                              </button>
                            </li>
                            {Array.from({ length: totalPages }, (_, index) => (
                              <li key={index} 
                              className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                  {index + 1}
                                </button>
                              </li>
                            ))}
                            <li className="page-item">
                              <button className="page-link" onClick={() => handlePageChange('next')} disabled={currentPage === totalPages}>
                                Next
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                )}
              </div>  
            </div>
          </div>

          {isModalOpen && selectedDetail && (
              <div className="modal modal-lg show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Product</h5>
                      <span className="badge bg-info ms-3">{selectedDetail.date}</span>
                      <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                    </div>
                    <div className="modal-body">
                      <div className="details-grid">
                        <div className="detail-item">
                          <strong>Date:</strong>
                          <span>{formatDateInternational(selectedDetail.created_at  ) || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Product:</strong>
                          <span>{selectedDetail.product_name || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Qty:</strong>
                          <span>{selectedDetail.quantity || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Price:</strong>
                          <span>{selectedDetail.total_amount || 'N/A'}</span>
                        </div>
                        <div className="detail-item">
                          <strong>Created By:</strong>
                          <span>{selectedDetail.created_by_name || 'N/A'}</span>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
          )}
          </>
        );
      }

      const Recipe = ({activeTab, setActiveTab, toggleTab , rowsRecipe, setRowsRecipe}) => {
        const rec = receipt[0]?.data ?? [];
        const [currentPage, setCurrentPage] = useState(1);
        const [limit, setLimit] = useState(2); // Default 2 data per halaman

        const [isModalOpen, setIsModalOpen] = useState(false);
        const [selectedDetail,setSelectedDetail] = useState(null);


        if (isSaving) {
            return (
              <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(255,255,255,0.3)', // transparan
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            );
        }

        const totalPages = Math.ceil(rec.length / limit);
       
        const handleLimitChange = (newLimit) => {
          setLimit(Number(newLimit));
          setCurrentPage(1); // Reset ke halaman pertama
        };

        const paginatedData = rec.slice((currentPage - 1) * limit, currentPage * limit);

        const handlePageChange = (page) => {
          if (page === 'prev') {
            setCurrentPage((prev) => Math.max(prev - 1, 1));
          } else if (page === 'next') {
            setCurrentPage((prev) => Math.min(prev + 1, totalPages));
          } else {
            setCurrentPage(page);
          }
        };

        const handleDetailClick = (detail) => {
          setSelectedDetail(detail);
          setIsModalOpen(true);
        };

        const handleCloseModal = () => {
          setIsModalOpen(false);
          setSelectedDetail(null);
        };

        const handleSubmit= async (e) => {
          e.preventDefault();
          // Handle form submission logic here
          const formData = new FormData(e.target);
          const datas = Object.fromEntries(formData);
          const rowsRecipe = [];
          let i = 0;
          while (datas[`recipe_${i}`] !== undefined) {
            rowsRecipe.push({
              product: datas[`recipe_${i}`],
              quantity: datas[`quantity_recipe_${i}`],
              pemakaian: datas[`pemakaian_recipe_${i}`],
              rule: datas[`rule_recipe_${i}`],
              notes: datas[`notes_receipt`],
            });
            i++;
          }

          setIsSaving(true);
          const promises = rowsRecipe.map(row => {
              const payload = {
                klinik_id: data.klinik_id,
                no_medical_record: data.no_medical_record,
                no_regist: data.no_regist,
                patient_id: patient.id,
                product_id: row.product,
                quantity: row.quantity,
                pemakaian: row.pemakaian,
                aturan_pakai: row.rule,
                created_by: user.user.id,
                notes: row.notes || ''
              };
              return fetch(`${API_BASE_URL}/auth/receipt_patient/create`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${user.token}`
                },
                body: JSON.stringify(payload)
              }).then(async response => {
                if (!response.ok) {
                  const errorData = await response.json().catch(() => ({}));
                  setNotifMessage(errorData.message || 'Gagal membuat receipt!');
                  setShowNotif(true);
                  setActiveTab("recipe");
                }
                return response.json();
              });
          });

          try {
            await Promise.all(promises);
            setNotifType('success');
            setNotifMessage('Receipt berhasil ditambahkan!');
            setShowNotif(true);
            // setRows([]);
            setActiveTab("recipe"); 
            await fetchDataRecipe();
          } catch (error) {
            setNotifType('danger');
            setActiveTab("recipe"); 
            setNotifMessage('Gagal membuat recipe!');
            setShowNotif(true);
          } finally {
            setIsSaving(false);
            setActiveTab("recipe");
          }
        }

        return (
          <>
          <div className='row g-6 g-xl-9'>
            <div className="col-md-6 col-xxl-6">
              <CardBasic 
                  className2={'d-flex flex-column p-2'}
              >
                  <div className='text-start'>
                    <ul className="nav nav-pills" id="pills-tab" role="tablist">
                      <li className="nav-item w-100" role="presentation">
                        <button
                          className="nav-link btn btn-primary w-100"
                          onClick={() => toggleTab("recipe")}
                        >
                          Receip
                        </button>
                      </li>
                    </ul>  
                  </div>
              </CardBasic>
              <div className="tab-content" id="pills-tabContent">
                {activeTab === "recipe" && (
                  <form onSubmit={handleSubmit}>
                  <div className="p-6 bg-light rounded border">
                    <div>
                      <h4 className="mb-4">Add Recipe</h4>
                      <h5 className="mb-3 text-muted">Add recipe for patient</h5>
                      {rowsRecipe.map((row, index) => (
                        <div className="row mb-3 align-items-center" key={index}>
                          <div className="col" style={{ minWidth: 180 }}>
                            <Select 
                              name={`recipe_${index}`}
                              options={masterProducts.status ? masterProducts.data.filter(prod => prod.group_id === 2).map(prod => ({ value: prod.id, label: prod.name })) : []}
                              value={
                                row.product ? { value: row.product, label: masterProducts.data.find(prod => prod.id === row.product)?.name || '' } : null
                              }
                              isClearable={true}
                              placeholder="Select a drug"
                              onChange={(selectedOption) => {
                                const newRows = [...rowsRecipe];
                                newRows[index].product = selectedOption?.value;
                                setRowsRecipe(newRows);
                              }}
                            />
                          </div>
                          <div className="col" style={{ minWidth: 180 }}>
                            <TextInput 
                              placeholder={'Quantity'}
                              name={`quantity_recipe_${index}`}
                              type={'number'}
                              value={row.quantity}
                              onChange={(e) => {
                                const newRows = [...rowsRecipe];
                                newRows[index].quantity = e.target.value;
                                setRowsRecipe(newRows);
                              }}
                              autoFocus={true}
                            />
                          </div>
                          <div className="col" style={{ minWidth: 180 }}>
                            <Select
                              name={`pemakaian_recipe_${index}`}
                              options={[
                                { value: '1x1', label: '1x1' },
                                { value: '2x1', label: '2x1' },
                                { value: '3x1', label: '3x1' },
                                { value: '4x1', label: '4x1' },
                                { value: '5x1', label: '5x1' },
                              ]}
                              value={
                                row.pemakaian ? { value: row.pemakaian, label: row.pemakaian } : null
                              }
                              isClearable={true}
                              placeholder="Select usage rule"
                              onChange={(selectedOption) => {
                                const newRows = [...rowsRecipe];
                                newRows[index].pemakaian = selectedOption?.value;
                                setRowsRecipe(newRows);
                              }}
                            />
                          </div>
                          <div className="col" style={{ minWidth: 180 }}>
                            <Select 
                              name={`rule_recipe_${index}`}
                              options={[
                                { value: 'Setelah Makan', label: 'Setelah Makan' },
                                { value: 'Sebelum Makan', label: 'Sebelum Makan' },
                                { value: 'Saat Makan', label: 'Saat Makan' },
                              ]}
                              value={
                                row.rule ? { value: row.rule, label: row.rule === '1' ? 'Setelah Makan' : row.rule === '2' ? 'Sebelum Makan' : 'Saat Makan' } : null
                              }
                              isClearable={true}
                              placeholder="Select rule"
                              onChange={(selectedOption) => {
                                const newRows = [...rowsRecipe];
                                newRows[index].rule = selectedOption?.value;
                                setRowsRecipe(newRows);
                              }}
                            />
                          </div>
                          <div className="col-1" style={{ minWidth: 40 }}>
                            <button
                              type="button"
                              className="btn btn-sm btn-light-danger"
                              onClick={() => setRowsRecipe(rowsRecipe.filter((_, i) => i !== index))}
                            >
                              X
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-sm btn-light-primary"
                        onClick={() => setRowsRecipe([...rowsRecipe, { product: '', quantity: '', pemakaian: '', rule: '' }])}
                      >
                        + Add Another Variation
                      </button>
                      <div className="mt-3 mb-3">
                        <textarea className="form-control" name='notes_receipt' id="notes" rows="3"></textarea>
                      </div>
                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-light-primary"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                  </form>
                )}
              </div> 
            </div>

            <div className="col-md-6 col-xxl-6">
              <CardBasic 
                  className2={'d-flex flex-column p-2'}
              >
                <div className='text-start'>
                  <ul className="nav nav-pills" id="pills-tab" role="tablist">
                    <li className="nav-item w-100" role="presentation">
                      <button
                          className="nav-link btn btn-primary w-100"
                          onClick={() => toggleTab("recipe")}
                      >
                        History Receipt
                      </button>
                    </li>
                  </ul>  
                </div>
              </CardBasic>

              <div className="tab-content" id="pills-tabContent">
                {activeTab === "recipe" && (
                  <div className="p-6 bg-light rounded border">
                    <h4 className="mb-4">Recipe</h4>
                    <h5 className="mb-3 text-muted">History Recipe</h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">Date</th>
                          <th scope="col">Recipe</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedData.map((item) => (
                          <tr key={item.id}>
                            <td>{formatDateInternational(item.created_at)}</td>
                            <td>{item.product_name}</td>
                            <td>
                              <button className="btn btn-light-success btn-sm"
                              onClick={() => handleDetailClick(item)}
                              >Detail</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>  
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        <select className="form-select" 
                        style={{ width: 'auto' }} 
                        onChange={(e) => handleLimitChange(e.target.value)}>
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                        </select>
                      </div>
                      <div>
                        <nav>
                          <ul className="pagination mb-0">
                            <li className="page-item">
                              <button className="page-link" 
                              onClick={() => handlePageChange('prev')} 
                              disabled={currentPage === 1}>
                                Previous
                              </button>
                            </li>
                            {Array.from({ length: totalPages }, (_, index) => (
                              <li key={index} 
                              className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                  {index + 1}
                                </button>
                              </li>
                            ))}
                            <li className="page-item">
                              <button className="page-link" onClick={() => handlePageChange('next')} disabled={currentPage === totalPages}>
                                Next
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                )}
              </div>  
            </div>
          </div>

          {isModalOpen && selectedDetail && (
            <div className="modal modal-lg show d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Recipe</h5>
                    <span className="badge bg-info ms-3">{selectedDetail.date}</span>
                    <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                  </div>
                  <div className="modal-body">
                    <div className="details-grid">
                      <div className="detail-item">
                        <strong>Date:</strong>
                        <span>{formatDateInternational(selectedDetail.created_at) || 'N/A'}</span>
                      </div>
                      <div className="detail-item">
                        <strong>Recipe:</strong>
                        <span>{selectedDetail.product_name || 'N/A'}</span>
                      </div>
                      <div className="detail-item">
                        <strong>Quantity:</strong>
                        <span>{selectedDetail.quantity || 'N/A'}</span>
                      </div>
                      <div className="detail-item">
                        <strong>Pemakaian:</strong>
                        <span>{selectedDetail.pemakaian || 'N/A'}</span>
                      </div>
                      <div className="detail-item">
                        <strong>Aturan Pakai:</strong>
                        <span>{selectedDetail.aturan_pakai || 'N/A'}</span>
                      </div>
                      <div className="detail-item">
                        <strong>Created By:</strong>
                        <span>{selectedDetail.created_by_name || 'N/A'}</span>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          </>
        );
      }

      return (
        <>
          <Examination activeTab={activeTab} setActiveTab={setActiveTab} toggleTab={toggleTab} patient={patient}/>
          <Diagnosis activeTab={activeTab} setActiveTab={setActiveTab} toggleTab={toggleTab} rowsDiagnosis={rowsDiagnosis}
            setRowsDiagnosis={setRowsDiagnosis}/>
          <Treatment activeTab={activeTab} setActiveTab={setActiveTab} toggleTab={toggleTab} rowsTreatment={rowsTreatment}
            setRowsTreatment={setRowsTreatment}/>
          <Products  activeTab={activeTab} setActiveTab={setActiveTab} toggleTab={toggleTab} masterProducts={masterProducts} rowsProducts={rowsProducts} setRowsProducts={setRowsProducts}/>
          <Recipe activeTab={activeTab} setActiveTab={setActiveTab} toggleTab={toggleTab} rowsRecipe={rowsRecipe} setRowsRecipe={setRowsRecipe}/>
        </>
      )
    }

    const Photo = ({ patient }) => {
      const [imagePreviews, setImagePreviews] = useState({});
      const [imageFiles, setImageFiles] = useState({});

      const handleImageChange = (e, index) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            setImagePreviews((prev) => ({
              ...prev,
              [index]: reader.result,
            }));
          };
          reader.readAsDataURL(file);

          setImageFiles((prev) => ({
            ...prev,
            [index]: file, // Simpan file asli
          }));
        }
      };

      const handleCancelImage = (index) => {
        setImagePreviews((prev) => ({
          ...prev,
          [index]: '', // Clear the preview for this input
        }));
        setImageFiles((prev) => ({
          ...prev,
          [index]: undefined,
        }));
      };

      const handleRemoveImage = (index) => {
        setImagePreviews((prev) => ({
          ...prev,
          [index]: '', // Hapus gambar dengan mengosongkan nilai preview
        }));
        setImageFiles((prev) => ({
          ...prev,
          [index]: undefined,
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        
        const formData = new FormData(e.target);

        setIsSaving(true);

        const description = formData.get('description');
        formData.append('user_id', user.user.id);
        formData.append('description', description);
        formData.append('klinik_id', data?.klinik_id);
        formData.append('no_medical_record', data?.no_medical_record);
        formData.append('no_regist', data?.no_regist);
        formData.append('session_date', new Date().toISOString().slice(0, 10));

        for (let i = 0; i < 6; i++) {
          if (imageFiles[i]) {
            formData.append(`photos[${i}][order_no]`, i + 1); // order_no 1-6
            formData.append(`photos[${i}][file]`, imageFiles[i]);
          }
        }

        try {
          const response = await fetch(`${API_BASE_URL}/auth/photo_patient/create`, {
            method: 'POST',
            body: formData,
          });
          if (response.ok) {
            // const result = await response.json();
            setImagePreviews({});
            setImageFiles({});
            e.target.reset();
            setIsSaving(false);
            setNotifType('success');
            setNotifMessage('Photo berhasil ditambahkan!');
            setShowNotif(true);  
          } else {
            setIsSaving(false);
            setNotifType('danger');
            setNotifMessage('Photo gagal ditambahkan!');
            setShowNotif(true);
          }
        } catch (error) {
          console.error('Error submitting form:', error);
          setIsSaving(false); 
        }
      };

      return (
        <>
          {isSaving && (
            <div
              style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(255,255,255,0.5)',
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          <div className='row g-6 g-xl-9 mb-5'>
            <div className="col-md-6 col-xxl-6">
              <form onSubmit={handleSubmit}>
              <CardBasic 
                  className={'d-flex flex-column p-2'}
                  header={
                    <div className="d-block mt-6 text-start">
                      <h4 className='mb-3'>Photos Patient</h4>
                      <h5 className="mb-2 fs-5 text-muted">Ambil foto sesuai dengan kebutuhan</h5>
                    </div>
                  }
                  className2={'text-center pt-0'}
              >
                <div className="row mb-4 mt-4">
                  {[1, 2, 3, 4, 5, 6].map((item, index) => (
                    <div className="col-md-4" key={index}>
                      <SInputImage imagePreview={imagePreviews[index]} 
                      onImageChange={(e) => handleImageChange(e, index)} 
                      onCancel={() => handleCancelImage(index)} 
                      onRemove={() => handleRemoveImage(index)}
                      inputName={`photo_${index + 1}`} />
                      <div className='text-center'>
                        <span className='text-muted fs-5'>Photos {item}</span>
                      </div>
                    </div>

                  ))}
                </div>
                <div className="row mb-5">
                  <div className='col-12 text-start'>
                    <label className='fs-5 fw-bold'>Description</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      name='description'
                      placeholder="Enter description here..."
                    ></textarea>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 text-start">
                    <button className="btn btn-secondary me-2">Clear</button>
                    <button type='submit' className="btn btn-primary">Save Changes</button>
                  </div>
                </div>
              </CardBasic>
              </form>
            </div>
            <div className="col-md-6 col-xxl-6">
              <CardBasic 
                  className={'d-flex flex-column p-2'}
                  header={
                    <div className="d-block mt-6 text-start">
                      <h4 className='mb-3'>History Photos</h4>
                      <h5 className="mb-2 fs-5 text-muted">Hasil foto</h5>
                    </div>
                  }
                  className2={'text-center pt-0'}
              >
                <div className="row">
                    {images && images.length > 0 ? (
                      images.map((item, idx) => (
                        <div className="col-md-4 mb-3" key={item.id || idx}>
                          <div className="card">
                            <img
                              src={`${BE_BASE_URL}storage/${item.photo_path}`}
                              alt={`Order ${item.order_no} pasien`} // contoh deskripsi yang lebih bermakna
                              className="card-img-top"
                              style={{ maxHeight: 100, objectFit: 'cover' }}
                            />
                            <div className="card-body">
                              <span className="fw-bold">Photo: {item.order_no}</span>
                              <br />
                              <span className="text-muted">{item.description}</span>
                              <br />
                              <span className="text-muted">{item.seesion_date}</span>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12 text-center text-muted py-5">
                        Belum ada foto yang diupload.
                      </div>
                    )}
                </div>
              </CardBasic>
            </div>
          </div>
        </>
      );
    }

    const MedicalRecord = ({patient}) => {
      const medicals = medical?.data || [];

      const [currentPage, setCurrentPage] = useState(1);
      const [limit, setLimit] = useState(2); // Default 2 data per halaman
      const totalPages = Math.ceil(medicals.length / limit);

      const handleLimitChange = (newLimit) => {
        setLimit(Number(newLimit));
        setCurrentPage(1); // Reset ke halaman pertama
      };

      const paginatedData = medicals.slice((currentPage - 1) * limit, currentPage * limit);

      const handlePageChange = (page) => {
        if (page === 'prev') {
          setCurrentPage((prev) => Math.max(prev - 1, 1));
        } else if (page === 'next') {
          setCurrentPage((prev) => Math.min(prev + 1, totalPages));
        } else {
          setCurrentPage(page);
        }
      };

      return (
        <>
          <div className='row g-6 g-xl-9 mb-5'>
            <div className="col-md-12 col-xxl-12">
              <CardBasic
                  className={'d-flex flex-column p-2'}
                  header={
                    <div className="d-block mt-6 text-start">
                      <h4 className='mb-3'>Medical Record</h4>
                    </div>
                  }
                  className2={'text-center pt-0'}
              >
                <div className="row mb-4 mt-4">
                  <div className="col-12">
                    <div className="table-responsive">
                      <table className="table align-middle table-row-dashed fs-6 gy-5">
                          <thead>
                              <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                  <th className="min-w-35px">Date</th>
                                  <th className="min-w-35px">Status</th>
                                  <th className="min-w-75px text-end">Amount</th>
                                  <th className="min-w-75px text-end">Actions</th>
                              </tr>
                          </thead>
                          <tbody className="fw-semibold text-gray-600">
                              {paginatedData.map((item,idx) => (
                                <tr key={idx}>
                                  <td className="text-start">{item.visit_date}</td>
                                  <td className="text-start">
                                  {item.status === 'paid' ? (
                                    <span className="badge bg-light-success">Sukses</span>
                                  ) : (
                                    <span className="badge bg-light-danger">Gagal</span>
                                  )}
                                  </td>
                                  <td className="text-end">{item.amount}</td>
                                  <td className="text-end">
                                    <SButton
                                        className={'btn btn-light-success btn-sm'}
                                        variant={'btn-light-success'}
                                        size={'sm'}
                                        action={() => navigate('medical-record',{
                                            state: {
                                                ...item,
                                                data,
                                                patient,
                                                from: [
                                                  { label: 'Patient', path: '/patient' },
                                                  { label: 'Doctor Review', path: `/doctor-review?id=${item.id}` },
                                                ]
                                            }
                                        })}    
                                    >
                                        View
                                    </SButton>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                      </table>
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                          <select className="form-select" 
                          style={{ width: 'auto' }} 
                          onChange={(e) => handleLimitChange(e.target.value)}>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                          </select>
                        </div>
                        <div>
                          <nav>
                            <ul className="pagination mb-0">
                              <li className="page-item">
                                <button className="page-link" 
                                onClick={() => handlePageChange('prev')} 
                                disabled={currentPage === 1}>
                                  Previous
                                </button>
                              </li>
                              {Array.from({ length: totalPages }, (_, index) => (
                                <li key={index} 
                                className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                  <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                    {index + 1}
                                  </button>
                                </li>
                              ))}
                              <li className="page-item">
                                <button className="page-link" onClick={() => handlePageChange('next')} disabled={currentPage === totalPages}>
                                  Next
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBasic>
            </div>
          </div>
        </>
      );
    }

    return (
      <>
        <div className="tab-content" id="myTabContent">
          <div className="tab-pane fade show active" id="kt_assesment" role="tabpanel">
            <Assesment activeTab={activeTab} setActiveTab={setActiveTab} toggleTab={toggleTab} patient={patientData} />
          </div>
          <div className="tab-pane fade" id="kt_photo" role="tabpanel">
              <Photo patient={patientData} />
          </div>
          <div className="tab-pane fade" id="kt_record" role="tabpanel">
              <MedicalRecord patient={patientData} />
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
        <Breadcrumb title={'Home'} header={'Doctor Review'}/>
        <div className='app-container container-xxl d-flex'>
            <div className='app-main flex-column flex-row-fluid' id="kt_app_main">
                <div className='d-flex flex-column flex-column-fluid'>
                    <div className='app-content'>
                        <CardBasic
                          className={'mb-6 mb-xl-9'}
                          className2={'pt-9 pb-0'}
                        >
                          <Profile />
                        </CardBasic>
                        <Tab patient={patientData} />
                    </div>
                </div>
                <SFooter />
            </div>
        </div>
      </div>
    </>
  )
}

export default DoctorReview